export default __webpack_public_path__ + "824729560efe6f0cccd8aaafc710035e.svg";